/**
 * @snippet AppHeader
 * @description Standardized Top-Bar Shell.
 */
import { Text } from '../elements/text.element';
import { Pulse } from '../elements/pulse.element';

import { Button } from '../elements/Button.jsx';
export const AppHeader = ({ onMenuToggle, pathName, isShieldActive, identity, showMenuToggle = true }) => (
  <header className="sticky top-0 z-40 flex h-16 items-center justify-between border-b border-gray-200 bg-background/95 px-4 backdrop-blur md:px-6">
    <div className="flex items-center gap-4">
      {showMenuToggle && (
        <Button variant="ghost" size="icon" className="lg:hidden" icon={false} onClick={onMenuToggle} aria-label="Open navigation menu">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
          </svg>
        </Button>
      )}

      <div className="flex items-center gap-3">
        <div className="hidden md:block">
          <Text variant="label" className="text-gray-400">
            Workspace
          </Text>
          <Text variant="body" className="block text-sm font-medium capitalize text-neutral">
            {pathName}
          </Text>
        </div>

        {isShieldActive && (
          <div className="flex items-center gap-2 rounded-full border border-red-200 bg-red-50 px-3 py-1">
            <Pulse color="bg-red-600" />
            <Text variant="error" className="text-xs text-red-700">AI Shield Active</Text>
          </div>
        )}
      </div>
    </div>

    <div className="flex items-center gap-4">
      {identity}
    </div>
  </header>
);
